<script>
import PInput from '../p-input.vue'
import PCard from '../p-card.vue'
import userService from '../../services/user.js'
import {validate} from '../../utils/'

export default {
    name: "p-user-pass",
    components:{
        PInput,
        PCard
    },
    data() {
        return {
            errors: [],
            success:false,
            submitDisabled: false,
            successMessage : "default",
            user : {
                oldPass : "",
                newPass : "",
                newPass2 : ""
            },
        }
    },
    methods: {
        submit(e){
            this.errors = [];
            this.success = false;
            this.submitDisabled = true;
            this.validate(e);
            if (this.user.newPass != this.user.newPass2){
                this.errors.push("Por favor, repita corretamente sua nova senha.");
            }
            if (!this.errors.length) {
                userService.updatePassword(this.user)
                .then(response => {
                    this.submitDisabled = false;
                    if (!response.data.erro) {
                        this.success = true;
                        this.successMessage = response.data.mensagem;
                    } else {
                        this.success = false;
                        this.errors.push(response.data.mensagem);
                    }
                }, err => {
                console.log(err);
                })
            } else {
                this.submitDisabled = false;
            }
        },
        validate(e) {
            // o modulo de validacao era em outro formato anteriormente, com a atualizacao
            // é necessário converter de object para array, pois anteriormente era array :/
            let errors = {};
            errors = validate(e);
            if (!!Object.keys(errors).length) {
                for (let error in errors) {
                    if (errors.hasOwnProperty(error)) {
                        this.errors.push(errors[error]);
                    }
                }
            }
        },
    },
    created: function() {}
}
</script>
<template>
    <div class="wrapper">
       <transition name="fade">
           <ul class="messages" v-if="errors.length || success">
              <h1>{{errors.length?'Ops.': ':)'}}</h1>
              <li v-if="errors.length" v-for="e in errors" class="d-flex align-items-center">
                 <i class="p-icon error rouded mr-1">
                    <svg class="icon"><use xlink:href="#sprite-error"/></svg>
                 </i>
                 <span>{{e}}</span>
              </li>
              <li v-if="success && errors.length == 0" class="d-flex flex-align-center">
                 <i class="p-icon success rouded mr-1">
                    <svg class="icon"><use xlink:href="#sprite-success"/></svg>
                 </i>
                 <span>{{successMessage}}</span>
              </li>
           </ul>
       </transition>

       <p-card>
          <form action="" @submit.prevent="submit" class="p-form" novalidate>
             <div class="fields">
                <div class="form-inline">
                   <p-input name="old-pass"
                            required="true"
                            label="Senha Atual"
                            type="password"
                            v-model="user.oldPass">
                    </p-input>
                </div>
                <div class="form-inline">
                   <p-input name="new-pass"
                            required="true"
                            minlength="8"
                            label="Nova Senha"
                            type="password"
                            validate="new-pass"
                            v-model="user.newPass">
                    </p-input>
                </div>
                <div class="form-inline">
                   <p-input name="new-pass2"
                            required="true"
                            minlength="8"
                            label="Repita Senha"
                            type="password"
                            v-model="user.newPass2">
                    </p-input>
                </div>

             </div>
             <p>A senha deve possuir no mínimo 8 caracteres e conter letras e números.</p>
             <div class="footer p-2 d-flex justify-content-end align-items-center">
                 <a href="editar-usuario.php" class="btn btn-primary" name="button" title="Voltar" style="margin-right : 8px"><span class="text">Voltar</span></a>
                 <button type="submit" :disabled="submitDisabled" class="btn btn-primary" name="button" title="Cadastrar"><span class="text">Salvar</span></button>
             </div>
          </form>
       </p-card>
    </div>
</template>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/js/components/profile/p-user-pass.vue